<template>
  <div class="p-3">
    <p>
      <slot name="message">
        {{ message }}
      </slot>
    </p>
    <v-hover v-slot="{ hover }">
      <v-btn
        :color="type ? type : hover ? 'theme' : 'nitro'"
        depressed
        class="my-2 my-sm-0 font-weight-bold text-white"
        :to="to"
      >
        <slot name="button">
          {{ btnText ? btnText : 'Acessar o módulo' }}
        </slot>
      </v-btn>
    </v-hover>
    <slot />
  </div>
</template>
<script>

export default {
  props:{
    message:{
      type: String,
      default: ''
    },
    btnText:{
      type:String,
      default: 'Continue estudando'
    },
    to:{
      type:Object,
      required:true,
    },
    type:{
      type:String,
      required: false,
      default: ''
    },
  }
}
</script>
